import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api/v1';

// Public API client (no auth required)
const publicClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const portalService = {
  getOrderStatus: (orderNumber, phone, shopId) => {
    let url = `/portal/order/${orderNumber}?phone=${encodeURIComponent(phone || '')}`;
    if (shopId) url += `&shopId=${shopId}`;
    return publicClient.get(url);
  },
};

export default portalService;
